import { all, call, put, takeLatest } from 'redux-saga/effects';

import { getTwoFactorConfiguration, updateTwoFactorConfiguration } from '@api/twoFactorConfiguration';
import {
  fetchData,
  fetchDataFailed,
  fetchDataSucceeded,
  toggleConfig,
  toggleConfigFailed,
  toggleConfigSucceeded,
} from '@redux/ducks/twoFactorConfiguration';

// Workers

export function* fetchDataTask() {
  try {
    const response = yield call(getTwoFactorConfiguration);

    yield put(fetchDataSucceeded(response));
  } catch (err) {
    yield put(fetchDataFailed());
  }
}

export function* toggleConfigTask({ payload }) {
  try {
    const response = yield call(updateTwoFactorConfiguration, payload);

    yield put(toggleConfigSucceeded(response));
  } catch (err) {
    yield put(toggleConfigFailed());
  }
}

// Watchers

export function* watchFetchData() {
  yield takeLatest(fetchData, fetchDataTask);
}

export function* watchToggleConfig() {
  yield takeLatest(toggleConfig, toggleConfigTask);
}

// Saga

export default function* twoFactorConfigurationSaga() {
  yield all([watchFetchData(), watchToggleConfig()]);
}
